// components
import { VoucherInfo } from 'components/voucher-info/voucher-info';
import { VoucherDisplay } from 'components/voucher-form/voucher-display';

// types
import type { Voucher } from 'utils/hooks/useVoucher';

export type VoucherProps = {
  voucher: Voucher;
  displayOnly: boolean;
};

export function Voucher({ voucher, displayOnly }: Readonly<VoucherProps>) {
  const {
    voucherCode,
    appliedVoucher,
    voucherInfo,
    voucherErrorMessage,
    handleVoucherInputChange,
    applyVoucher,
    removeVoucher,
  } = voucher;

  return (
    <>
      <VoucherInfo voucherInfo={voucherInfo} voucherErrorMessage={voucherErrorMessage} />
      <VoucherDisplay
        voucherCode={voucherCode}
        appliedVoucher={appliedVoucher}
        handleVoucherInputChange={handleVoucherInputChange}
        applyVoucher={applyVoucher}
        removeVoucher={removeVoucher}
        displayOnly={displayOnly}
      />
    </>
  );
}
